import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { paths } from '@src/routes/paths';
import { LoadingScreen } from '@syntra/ui/components/loading-screen';

import WallLayout from 'src/layouts/wall';
import { AuthGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const IndexPage = lazy(() => import('../pages/UserAfterLoginPage'));

// ----------------------------------------------------------------------
export const userAfterLoginRoutes = [
  {
    path: paths.dashboard.user_after_login.index,
    element: (
      <AuthGuard>
        <WallLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </WallLayout>
      </AuthGuard>
    ),
    children: [{ element: <IndexPage />, index: true }],
  },
];
